import ErrorRobot from '@anm/components/errors/ErrorRobot';
import styled from 'styled-components';

export const ErrorGoHomeWrapper = styled(ErrorRobot)`
  min-height: 100vh;
`;
